export let state = {
    licenses: [],
    id: null,
    name: null,
    supportEmail: null,
    supportPhoneNumber: null,
    timeZone: null
}
